import React from 'react'
import './basic-button.css'

/**
 * Props to use when instantiating a `BasicButton` component.
 */
export interface BasicButtonProps extends React.HTMLProps<HTMLButtonElement & HTMLAnchorElement> {
  /**
   * Type of button, either a "button", "submit" button, or "link". defaults to "button".
   */
  type?: 'button' | 'submit' | 'link'

  /**
   * CSS class of button, either "primary" or "secondary". Defaults to "primary".
   */
  buttonStatus?: 'primary' | 'secondary' | 'negative'

  /**
   * Text to display
   */
  text?: string
}

/**
 * A basic button component, either a link or `button` element.
 * 
 */
export function BasicButton({
  type = 'button',
  buttonStatus = 'primary',
  disabled = false,
  className = '',
  onClick,
  text,
  children,
  href,
  ...otherProps
}: BasicButtonProps): JSX.Element {
  if (type !== "link") {
    return (<button
      type={type}
      onClick={onClick || (() => { })}
      className={`basic-button ${buttonStatus}${disabled ? ' disabled' : ''} ${className}`}
      disabled={disabled}
      {...otherProps}>
      {text}
      {children}
    </button>)
  } 
    return (
      <a className={`basic-button link-button ${buttonStatus}`} href={href} {...otherProps}>
        {text}
        {children}
      </a>
    )
  
}
